// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rxBT","col":"styles_col__m524a"};